import Layout from '@/views/juror/layout/Layout.vue'

export default [
  {
    name: 'JurorLayout',
    path: '/',
    redirect: { path: '/trial' },
    component: Layout,
    children: [
      // 我的陪审
      {
        name: 'Trial',
        path: 'trial',
        component: () => import(/* webpackChunkName: "Trial" */'@/views/juror/trial/home/Home.vue')
      },
      {
        name: 'CaseDetail',
        path: 'trial/case-detail',
        component: () => import(/* webpackChunkName: "CaseDetail" */'@/views/juror/trial/detail/CaseDetail.vue')
      },
      // 陪审签到
      {
        name: 'Signed',
        path: 'signed',
        component: () => import(/* webpackChunkName: "Signed" */'@/views/juror/signed/Home.vue'),
        meta: {
          register: 'wx'
        }
      },
      // 通知公告
      {
        name: 'Announcement',
        path: 'announcement',
        component: () => import(/* webpackChunkName: "Announcement" */'@/views/juror/announcement/Home.vue')
      },
      // 庭审公告报名
      {
        name: 'TrialNoticeJoin',
        path: '/announcement-trial-notice-join',
        component: () => import(/* webpackChunkName: "Announcement" */'@/views/juror/announcement/join/Home.vue')
      },
      {
        name: 'AnnouncementDetail',
        path: 'announcement-detail',
        component: () => import(/* webpackChunkName: "AnnouncementDetail" */ '@/views/juror/announcement/AnnouncementDetail.vue')
      },
      {
        name: 'LearningDetail',
        path: 'learning-detail',
        component: () => import(/* webpackChunkName: "LearningDetail" */ '@/views/juror/announcement/LearningDetail.vue')
      },
      // 个人中心
      {
        name: 'My',
        path: 'my',
        redirect: { name: 'MyHome' },
        component: () => import(/* webpackChunkName: "My" */'@/views/juror/my/index.vue'),
        children: [
          {
            name: 'MyHome',
            path: '',
            component: () => import(/* webpackChunkName: "MyHome" */'@/views/juror/my/Home.vue')
          },
          {
            name: 'MyProfile',
            path: 'profile',
            component: () => import(/* webpackChunkName: "Profile" */'@/views/juror/my/Profile.vue')
          },
          {
            name: 'ModifyPwd',
            path: 'modify-pwd',
            component: () => import(/* webpackChunkName: "ModifyPwd" */'@/views/juror/my/ModifyPwd.vue')
          },
          {
            name: 'ModifyPhoneNum',
            path: 'modify-phone-num',
            component: () => import(/* webpackChunkName: "ModifyPhoneNum" */'@/views/juror/my/ModifyPhoneNum.vue')
          },
          {
            name: 'ESign',
            path: 'e-sign',
            component: () => import(/* webpackChunkName: "ESign" */'@/views/juror/my/ESign.vue')
          },
          {
            name: 'AddESign',
            path: 'add-e-sign',
            component: () => import(/* webpackChunkName: "AddESign" */'@/views/juror/my/AddESign.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/signature-document/:docId',
    name: 'SignatureOfDocument',
    component: () => import(/* webpackChunkName: "SignatureOfDocument" */ '@/views/signatureOfDoc/Home.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "notFound" */'@/views/error/404.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/permissionRoutes/jurorRoutes.js